import React from "react";
import { Box } from "@mui/system";
import { styled } from "@mui/system";
import background from "../assets/front_door.jpeg";

// Update the container to center its content
const VignetteContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex", // Change from inline-block to flex
  justifyContent: "center", // Center horizontally
  alignItems: "center", // Center vertically
  width: "100%", // Take full width of parent
  height: "600px", // Fixed height for the bar - adjust as needed
  overflow: "hidden", // This will crop the image
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    background:
      "linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 30%, transparent 10%)",
  },
}));

// Clean up the BackgroundBox styling
const BackgroundBox = styled("img")({
  height: "100%",
  width: "100%",
  objectFit: "cover",
  objectPosition: "center", // You can adjust this to control which part of the image is shown

  // Remove duplicated height property
  // Remove unnecessary background properties for an <img> element
});

export default function Background() {
  return (
    <VignetteContainer>
      <BackgroundBox src={background} alt="Background" />
    </VignetteContainer>
  );
}
